import isNumber from "lodash/isNumber";

import { parseAsFloat } from "utils";

const isNumeric = (value) => !isNumber(parseAsFloat(value));

const isPositive = (value) => isNumeric(value) || value < 0;

export { isNumeric, isPositive };
